import { useEffect, useState, useCallback } from "react";
import PageShell from "@/components/PageShell";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

export default function Fabrics() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [name, setName] = useState("");

  const load = useCallback(() => { api.get("/fabric-types").then((r) => setItems(r.data)); }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setName(edit ? edit.name : ""); }, [edit]);

  const close = (v) => { setOpen(v); if (!v) { setEdit(null); setName(""); } };
  const submit = async () => {
    if (!name) return toast.error("Isi nama kain");
    try {
      if (edit) await api.put(`/fabric-types/${edit.id}`, { name });
      else await api.post("/fabric-types", { name });
      toast.success("Jenis kain disimpan"); close(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => {
    try { await api.delete(`/fabric-types/${id}`); toast.success("Dihapus"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <PageShell title="Master Jenis Kain">
      <div className="flex justify-end">
        <Dialog open={open} onOpenChange={close}>
          <DialogTrigger asChild><Button data-testid="add-fabric-button"><Plus className="h-4 w-4 mr-1.5" />Tambah Jenis Kain</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{edit ? "Edit" : "Tambah"} Jenis Kain</DialogTitle><DialogDescription className="sr-only">Form jenis kain</DialogDescription></DialogHeader>
            <div className="space-y-1.5"><Label>Nama Kain</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="fabric-name-input" /></div>
            <DialogFooter><Button variant="outline" onClick={() => close(false)}>Batal</Button><Button onClick={submit} data-testid="fabric-submit-button">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Card className="shadow-sm"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow><TableHead>Nama Jenis Kain</TableHead><TableHead className="w-24"></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((f) => (
              <TableRow key={f.id} data-testid={`fabric-row-${f.id}`}>
                <TableCell className="font-medium">{f.name}</TableCell>
                <TableCell className="flex gap-1">
                  <Button variant="ghost" size="icon" onClick={() => { setEdit(f); setOpen(true); }} data-testid={`fabric-edit-${f.id}`}><Pencil className="h-4 w-4" /></Button>
                  <Button variant="ghost" size="icon" onClick={() => del(f.id)} data-testid={`fabric-delete-${f.id}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={2} className="text-center text-slate-400 py-8">Belum ada jenis kain.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </PageShell>
  );
}
